// googleMaps.js (v230.11.0)
// Lazy, single-shot loader for the Google Maps JS SDK (with the Places library)
// plus a haversine helper. The SDK is only ever loaded when a browser key is
// present (VITE_GOOGLE_MAPS_KEY); absent key => callers fall back to list-only.

let _mapsPromise = null

export function loadGoogleMaps(key) {
  if (typeof window === 'undefined') return Promise.reject(new Error('no window'))
  if (window.google && window.google.maps) return Promise.resolve(window.google.maps)
  if (_mapsPromise) return _mapsPromise
  if (!key) return Promise.reject(new Error('no maps key'))
  _mapsPromise = new Promise((resolve, reject) => {
    const cbName = '__orellaGmapsReady'
    window[cbName] = () => {
      resolve(window.google.maps)
      try { delete window[cbName] } catch { /* noop */ }
    }
    const s = document.createElement('script')
    s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places&callback=${cbName}&loading=async`
    s.async = true
    s.defer = true
    s.onerror = () => { _mapsPromise = null; reject(new Error('maps script failed')) }
    document.head.appendChild(s)
  })
  return _mapsPromise
}

export function haversineMiles(lat1, lng1, lat2, lng2) {
  const toRad = (x) => (x * Math.PI) / 180
  const R = 3958.8 // miles
  const dLat = toRad(lat2 - lat1)
  const dLng = toRad(lng2 - lng1)
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)))
}
